/* eslint-disable react/jsx-no-bind */
import classNames from 'classnames';
import React, { FC, ReactElement } from 'react';

import Button from '../../Button';
import { IconButton } from '../../Icon/';
import withAnimation, {
  withAnimationProps,
  CloseAnimation,
} from '../../withAnimation';

import styles from './Inline.module.scss';

export interface InlineProps extends withAnimationProps {
  title: string;
  button: { label?: string; onClick: () => void };
  cue?: string | ReactElement;
  image?: ReactElement;
  imageOffset?: boolean;
  mini?: boolean;
  closeAnimation?: CloseAnimation;
}

const Inline: FC<InlineProps> = ({
  title,
  button,
  cue,
  image,
  imageOffset,
  mini = false,
  closeAnimation,
  ...rest
}) => {
  const handleOnClick = (): void => {
    button.onClick();
    closeAnimation();
  };

  return (
    <>
      {mini && (
        <div
          className={classNames(styles.CueInline, styles.CueInlineMini)}
          data-testid={'OneUI-Cue-Inline-Mini'}
          {...rest}
        >
          <span
            className={styles.CueInlineText}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {button.label ? (
            <Button
              variant="secondary"
              label={button.label}
              onClick={button.onClick}
              className={styles.CueInline__miniButton}
            />
          ) : (
            <IconButton
              className={styles.CueInlineIconButton}
              name="link"
              alt={title}
              onClick={button.onClick}
              size={20}
            />
          )}
        </div>
      )}
      {!mini && (
        <div
          className={classNames(styles.CueInline, {
            [styles.CueInlineOffset]: imageOffset,
          })}
          data-testid={'OneUI-Cue-Inline'}
          {...rest}
        >
          <h4 className={styles.CueInlineHeading}>{title}</h4>
          <div className={styles.CueInlineText}>{cue}</div>
          <Button
            variant="primary"
            square
            stroke
            className={styles.CueInlineButton}
            label={button.label}
            onClick={handleOnClick}
          />
          <div
            className={classNames(
              styles.CueInlineImageContainer,
              imageOffset && styles.CueInlineImageContainerOffset
            )}
          >
            {image}
          </div>
        </div>
      )}
    </>
  );
};

export default withAnimation(Inline);
